import React, { useState, useContext } from "react";
import { makeStyles } from "@material-ui/styles";
import {
  Paper,
  Grid,
  Typography,
  List,
  ListItem,
  IconButton,
  Tooltip,
} from "@material-ui/core";
import { FaFacebookF, FaTwitter, FaInstagram, FaYoutube } from "react-icons/fa";
import { MdEmail } from "react-icons/md";
import { FiSmartphone } from "react-icons/fi";
import { GoLocation } from "react-icons/go";
import { LangContext } from "../../../Context/Langcontext";
import useReactRouter from "use-react-router";

const useStyle = makeStyles((theme) => ({
  Position: { height: "100%", width: "100%" },
  PaperSize: {
    background: "#f8f8f6",
    boxShadow: "unset",
    height: "68%",
    // paddingTop: "2rem",
    // paddingBottom: "1rem",
  },
  root: { width: "100%", height: "80%" },
  headtext: {
    height: "3rem",
    display: "flex",
    alignItems: "center",
    paddingLeft: "2.5rem",
  },
  list: {
    paddingLeft: "2.5rem",
    paddingTop: "unset",
  },
  itemcenter: {
    width: "100%",
    height: "100%",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },
  text: {
    fontSize: "1rem",
    color: "#595A5A",
    fontWeight: 200,
    maxWidth: "85%",
  },
  maintext: {
    fontSize: "1.2rem",
    color: "#595A5A",
    fontWeight: 700,
  },
  detailtext: {
    fontSize: "1rem",
    color: "#595A5A",
    fontWeight: 200,
  },
  cursortext: {
    fontSize: "1rem",
    color: "#595A5A",
    fontWeight: 200,
    cursor: "pointer",
    "&:hover": {
      color: "#E16733",
    },
  },
  border: {
    height: "20%",
    width: "100%",
    borderTop: "1px solid #cecccc",
    alignItems: "center",
    marginTop: "1rem",
  },
  icon: {
    backgroundColor: "#595A5A",
    color: "#FFFFFF",
    fontSize: theme.spacing(1),
    margin: "0.5rem",
    "&:hover": { background: "#595A5Ad9" },
  },
  logo: {
    width: "auto",
    height: "3.5rem",
  },
  hundren: {
    height: "100%",
    width: "100%",
  },
  circlestyle: {
    color: "#E16733",
    marginRight: "1rem",
    fontSize: "0.5rem",
  },
  listitem: {
    paddingLeft: "unset",
    paddingRight: "unset",
  },
  iconf: { marginRight: "1rem", color: "#E16733", fontSize: "1.2rem" },
  iconsocial: { fontSize: theme.spacing(1) },
}));

const Footer = () => {
  const langContext = useContext(LangContext);
  const lang = langContext.lang.data;
  const { history } = useReactRouter();

  const classes = useStyle();
  const about = [
    { title: lang.HOME, path: "/home" },
    { title: lang.SERVICE, path: "/home/service" },
    { title: lang.PRICING, path: "/home/pricing" },
    { title: lang.DOCUMENT, path: "/home/document" },
    { title: lang.SUPPORT, path: "/home/support" },
  ];
  const service = [
    {
      title: lang.DataService,
      path: "mea_data_service",
    },
    {
      title: lang.MapService,
      path: "mea_map_service",
    },
  ];

  const lagal = [
    { title: lang.TermCondition, path: "/terms" },
    { title: lang.Privacy, path: "/privacy" },
  ];

  const contact = [
    {
      by: "phone",
      value: "02-611-5357, 02-611-5630",
      icon: <FiSmartphone className={classes.iconf} />,
    },
    {
      by: "mail",
      value: "apigis@mea.or.th",
      icon: <MdEmail className={classes.iconf} />,
    },
    {
      by: "address",
      value: "Metropolitan Electricity Authority",
      icon: <GoLocation className={classes.iconf} />,
    },
  ];

  const [social] = useState([
    {
      title: "twitter",
      icon: <FaTwitter size={14} />,
      link: "https://twitter.com/mea_news",
    },
    {
      title: "youtube",
      icon: <FaYoutube size={14} />,
      link: "https://www.youtube.com/user/MEAmultimedia/",
    },
    {
      title: "facebook",
      icon: <FaFacebookF size={14} />,
      link: "https://www.facebook.com/METROPOLITAN.ELECTRICITY.AUTHORITY/",
    },
    {
      title: "instagram",
      icon: <FaInstagram size={14} />,
      link: "https://www.instagram.com/meafanclub/",
    },
  ]);

  return (
    <Paper className={classes.PaperSize}>
      <div className={classes.itemcenter}>
        <div style={{ margin: "2.25rem 0rem 0rem 0rem", width: "85%" }}>
          <Grid container className={classes.root} spacing={1}>
            <Grid item md={3} sm={12}>
              <img
                alt="logo"
                src={require("../../../images/LOGO/logo2.png")}
                className={classes.logo}
              />
              <Typography className={classes.text}>
                {lang.SubtitlesFooter}
              </Typography>
            </Grid>
            <Grid item md={2} sm={6} xs={12}>
              <div className={classes.hundren}>
                <div className={classes.headtext}>
                  <Typography className={classes.maintext}>
                    {lang.About.toUpperCase()}
                  </Typography>
                </div>

                <List className={classes.list}>
                  {about.map((item) => {
                    return (
                      <ListItem
                        key={item.title}
                        style={{
                          paddingLeft: "unset",
                          paddingRight: "unset",
                        }}
                        onClick={() => {
                          history.push(item.path);
                          window.scrollTo(0, 0);
                        }}
                      >
                        <Typography className={classes.cursortext}>
                          {item.title}
                        </Typography>
                      </ListItem>
                    );
                  })}
                </List>
              </div>
            </Grid>
            <Grid item md={2} sm={6} xs={12}>
              <div className={classes.hundren}>
                <div className={classes.headtext}>
                  <Typography className={classes.maintext}>
                    {lang.SERVICE.toUpperCase()}
                  </Typography>
                </div>

                <List className={classes.list}>
                  {service.map((item) => {
                    return (
                      <div key={item.title}>
                        <ListItem
                          key={item.title}
                          className={classes.listitem}
                          onClick={() => {
                            // history.push(res.path);
                            history.push(`/home/document/#${item.path}`);

                            setTimeout(() => {
                              let element = document.getElementById(item.path);
                              let offTop = element.offsetTop;
                              window.scrollTo({
                                top: offTop - 100,
                                left: 0,
                                behavior: "smooth",
                              });
                            }, 1000);
                          }}
                        >
                          <Typography className={classes.cursortext}>
                            {item.title}
                          </Typography>
                        </ListItem>
                      </div>
                    );
                  })}
                </List>
              </div>
            </Grid>
            <Grid item md={2} sm={6} xs={12}>
              <div className={classes.hundren}>
                <div className={classes.headtext}>
                  <Typography className={classes.maintext}>
                    {lang.Legal.toUpperCase()}
                  </Typography>
                </div>

                <List className={classes.list}>
                  {lagal.map((item) => {
                    return (
                      <ListItem key={item.title} className={classes.listitem}>
                        <Typography
                          className={classes.cursortext}
                          onClick={() => {
                            history.push(item.path);
                          }}
                        >
                          {item.title}
                        </Typography>
                      </ListItem>
                    );
                  })}
                </List>
              </div>
            </Grid>
            <Grid item md={3} sm={6} xs={12}>
              <div className={classes.hundren}>
                <div className={classes.headtext}>
                  <Typography className={classes.maintext}>
                    {lang.Contactus.toUpperCase()}
                  </Typography>
                </div>

                <List className={classes.list}>
                  {contact.map((item) => {
                    return (
                      <ListItem key={item.value} className={classes.listitem}>
                        {item.icon}
                        <Typography className={classes.detailtext}>
                          {item.value}
                        </Typography>
                      </ListItem>
                    );
                  })}
                </List>
              </div>
            </Grid>
          </Grid>
          <Grid
            container
            direction="row"
            alignItems="flex-end"
            className={classes.border}
          >
            <Grid item md={6} sm={12}>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Typography
                  // className={classes.detailtext}
                  style={{
                    marginRight: "0.5rem",
                    fontSize: "0.8rem",
                    color: "#595A5A",
                    fontWeight: 200,
                  }}
                >
                  ©
                </Typography>
                <Typography
                  style={{
                    fontSize: "0.8rem",
                    color: "#595A5A",
                    fontWeight: 200,
                  }}
                >
                  {`${
                    langContext.lang.locale === "en"
                      ? new Date().getFullYear()
                      : Number(new Date().getFullYear() + 543)
                  } ${lang.MEA}`}
                </Typography>
              </div>
            </Grid>
            <Grid
              item
              md={6}
              sm={12}
              style={{ display: "flex", justifyContent: "flex-end" }}
            >
              <div style={{ display: "flex" }}>
                {social.map((item) => {
                  return (
                    <Tooltip
                      key={item.title}
                      title={item.title}
                      placement="top"
                    >
                      <IconButton
                        className={classes.icon}
                        onClick={() => {
                          let a = document.createElement("a");

                          a.href = item.link;
                          a.target = "_blank";
                          a.click();
                        }}
                      >
                        {item.icon}
                      </IconButton>
                    </Tooltip>
                  );
                })}
              </div>
            </Grid>
          </Grid>
        </div>
      </div>
    </Paper>
  );
};

export default Footer;
